'use client'
import styled from 'styled-components'
import { useTranslator } from '@/hooks'
import { vw, mq } from '@/styles'
import { LinkStyled } from '@/components'

export const Main = () => {
  const { t } = useTranslator()

  return (
    <MainWrapper>
      <LinkStyled href='https://dynameatpro.blob.core.windows.net/iluzione/f6ddda49-a764-4df7-ab69-064cca37d937/4c68f1d9-bc0b-49a0-bd36-3ec2c19fe464/index.html#/?zone=65a8fd2a-923a-495c-af59-2385779cf5d5&avoidRedirect=true' target='_blank' rel='noopener noreferrer' outline> {t('layout.main.menu')} </LinkStyled>
    </MainWrapper>
  )
}


const MainWrapper = styled.main`
  align-items: center;
  display: flex;
  flex-direction: column;
  grid-column: 1 / span 6;
  grid-row: 1 / span 3;
  justify-content: flex-end;
  margin-bottom:${vw(60, 'mobile')};
  width: 100%;
  z-index: 91;

  ${mq.greaterThan('nexus7')} {
    margin-bottom: 107.246px;
  }

  ${mq.greaterThan('tablet')} {
    display: none;
  }

  a, button {
    cursor: pointer;
  }

  > a {
    height: ${vw(87, 'mobile')};
    width: ${vw(260, 'mobile')};

    ${mq.greaterThan('nexus7')} {
      height: 126.6px;
      width: 378px;
    }
  }

  @media screen and (min-width: 320px) and (max-width: 767px) and (orientation: landscape) {
    margin-bottom:${vw(30, 'mobile')};
  }
`
